import { render, staticRenderFns } from "./nbreport.vue?vue&type=template&id=fc2748aa&scoped=true&"
import script from "./nbreport.vue?vue&type=script&lang=js&"
export * from "./nbreport.vue?vue&type=script&lang=js&"
import style1 from "./nbreport.vue?vue&type=style&index=1&id=fc2748aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2748aa",
  null
  
)

export default component.exports